import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import AdminLayout from "../../components/admin/Layout/AdminLayout";

export default function BlogEditor() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  const [form, setForm] = useState({
    title: "",
    excerpt: "",
    content: "",
    tags: "",
    category: "",
    status: "draft",
    coverImage: null,
    preview: "",
  });

  // LOAD BLOG
  useEffect(() => {
    const loadBlog = async () => {
      try {
        const res = await api.get(`/blogs/admin/${id}`);
        const blog = res.data;

        setForm({
          title: blog.title || "",
          excerpt: blog.excerpt || "",
          content: blog.content || "",
          tags: blog.tags ? blog.tags.join(", ") : "",
          category: blog.category?._id || "",
          status: blog.status || "draft",
          coverImage: null,
          preview: blog.coverImage || "",
        });
      } catch (err) {
        console.error("BLOG LOAD ERROR:", err);
      } finally {
        setLoading(false);
      }
    };

    const loadCategories = async () => {
      try {
        const res = await api.get("/blogs/categories");
        setCategories(res.data);
      } catch (err) {
        console.error("CATEGORY LOAD ERROR:", err);
      }
    };

    loadBlog();
    loadCategories();
  }, [id]);

  // INPUT CHANGE
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // IMAGE CHANGE
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    setForm({
      ...form,
      coverImage: file,
      preview: URL.createObjectURL(file),
    });
  };

  // SAVE BLOG
  const handleSave = async () => {
    try {
      const formData = new FormData();

      formData.append("title", form.title);
      formData.append("excerpt", form.excerpt);
      formData.append("content", form.content);
      formData.append("status", form.status);
      formData.append("category", form.category);

      form.tags
        .split(",")
        .map((t) => t.trim())
        .forEach((tag) => formData.append("tags[]", tag));

      if (form.coverImage) {
        formData.append("coverImage", form.coverImage);
      }

      await api.put(`/blogs/admin/${id}`, formData);

      alert("Blog updated successfully");

      navigate("/admin/blogs");
    } catch (err) {
      console.error("BLOG UPDATE ERROR:", err);
      alert("Failed to update blog");
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <p>Loading blog...</p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="container" style={{ maxWidth: "900px" }}>
        <h2 className="mb-4">Edit Blog</h2>

        <div className="card p-4">

          {/* TITLE */}
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              className="form-control"
              name="title"
              value={form.title}
              onChange={handleChange}
            />
          </div>

          {/* EXCERPT */}
          <div className="mb-3">
            <label className="form-label">Excerpt</label>
            <input
              className="form-control"
              name="excerpt"
              value={form.excerpt}
              onChange={handleChange}
            />
          </div>

          {/* CATEGORY */}
          <div className="mb-3">
            <label className="form-label">Category</label>
            <select
              className="form-select"
              value={form.category}
              onChange={(e) =>
                setForm({ ...form, category: e.target.value })
              }
            >
              <option value="">Select category</option>

              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          {/* TAGS */}
          <div className="mb-3">
            <label className="form-label">Tags</label>
            <input
              className="form-control"
              name="tags"
              placeholder="seo, marketing, growth"
              value={form.tags}
              onChange={handleChange}
            />
          </div>

          {/* IMAGE */}
          <div className="mb-3">
            <label className="form-label">Cover Image</label>

            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={handleImageChange}
            />

            {form.preview && (
              <img
                src={form.preview}
                alt="preview"
                style={{
                  marginTop: "10px",
                  width: "200px",
                  borderRadius: "8px",
                }}
              />
            )}
          </div>

          {/* CONTENT */}
          <div className="mb-3">
            <label className="form-label">Content</label>

            <textarea
              className="form-control"
              rows="12"
              name="content"
              value={form.content}
              onChange={handleChange}
            />
          </div>

          {/* STATUS */}
          <div className="mb-3">
            <label className="form-label">Status</label>

            <select
              className="form-select"
              value={form.status}
              onChange={(e) =>
                setForm({ ...form, status: e.target.value })
              }
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </div>

          {/* ACTION */}
          <button
            className="btn btn-primary"
            onClick={handleSave}
          >
            Update Blog
          </button>

        </div>
      </div>
    </AdminLayout>
  );
}